import { useState } from 'react';
import { CopyAssistDropdownItemTextSkeleton } from 'modules/ai/copyAssist/components/dropdown/CopyAssistDropdownItemTextSkeleton';
import { CopyAssistDropdownItemIcon } from 'modules/ai/copyAssist/components/dropdown/CopyAssistDropdownItemIcon';
import {
  StyledDropdownItem,
  StyledDropdownItemWrapper,
  StyledGeneratedTextOption,
} from 'modules/ai/copyAssist/components/dropdown/styles';

interface CopyAssistDropdownItemProps {
  isSelected?: boolean;
  onClick?: (value: any) => void;
  id?: string;
  animationDuration?: number;
  optionText: string;
  isLoading: boolean;
  style?: React.CSSProperties;
}

export const CopyAssistDropdownItem = ({
  onClick,
  isSelected = false,
  optionText,
  isLoading,
  style,
}: CopyAssistDropdownItemProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  return (
    <StyledDropdownItem
      style={style}
      data-test="copy-assist-dropdown-item"
      isLoading={isLoading}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <StyledDropdownItemWrapper>
        <CopyAssistDropdownItemIcon isHovered={isHovered} isSelected={isSelected} />
        {isLoading ? (
          <CopyAssistDropdownItemTextSkeleton />
        ) : (
          <StyledGeneratedTextOption data-test="copy-assist-option-text">
            {optionText}
          </StyledGeneratedTextOption>
        )}
      </StyledDropdownItemWrapper>
    </StyledDropdownItem>
  );
};
